import React from "react";
import {connect} from "react-redux";
import axios from "axios";
import {Map, TileLayer, Polygon, FeatureGroup, GeoJSON, Marker, Popup, Polyline} from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import actionTypes from "../../../store/actionTypes";
import {IStore} from "../../../store/reducers";
import {IMapas, INotificacion, IParcela, ISections, IZona} from "../../../types";
import L, {LatLngTuple, LeafletEvent} from "leaflet";
import {Paper, TextField, Typography, Slider, FormControl, Button, CircularProgress} from "@material-ui/core";
import {PlayArrowOutlined} from '@material-ui/icons';
import ColorPicker from "react-pick-color";
import {userService} from "../../../services/UserService";
import Graph from "../../../icons/SVGs/Graph.svg"
import {resolucion_tablet} from "../../../tools/resolucion";
import ImageOverlayRotated from "../../../tools/ImageOverlayRotated";
import LocationIcon from "../../../icons/PNGs/location.png";
import * as THREE from "three";
import DeletePoint from "../../../icons/PNGs/delete_point.png";
import EditablePoint from "../../../icons/PNGs/editable_point.png";
import PushpinIcon from "../../../icons/PNGs/pushpin.png";
import CleanIcon from "../../../icons/PNGs/clean.png";
import RulerIcon from "../../../icons/PNGs/ruler.png";
import AreaIcon from "../../../icons/PNGs/area.png";
import NotaIcon from "../../../icons/PNGs/pencil.png";

const geolib = require('geolib');
const simplepolygon = require('simplepolygon')
const pointInPolygon = require('point-in-polygon');
const config = require('../../../config.json');
const texts = require('../../../texts/visualizador.json');


const location_icon = new L.Icon({
    iconUrl: LocationIcon,
    iconRetinaUrl: LocationIcon,
    iconSize: [30, 30]
})

const delete_icon = new L.Icon({
    iconUrl: DeletePoint,
    iconRetinaUrl: DeletePoint,
    iconSize: [25, 25]
})


const editable_icon = new L.Icon({
    iconUrl: EditablePoint,
    iconRetinaUrl: EditablePoint,
    iconSize: [25, 25]
})


const pushpin_icon = new L.Icon({
    iconUrl: PushpinIcon,
    iconRetinaUrl: PushpinIcon,
    iconSize: [40, 48],
    iconAnchor: [7, 48]
})


interface IProps {
    setMapa(mapa: IMapas): void
    setZoom(zoom: number): void
    setCenter(center: LatLngTuple): void
    setBounds(bounds: LatLngTuple[]): void
    setZonificacion(zonificacion: boolean): void
    notify(notification: INotificacion): void
    setHistograma(histograma: Record<string, number>[]): void
    setPropsZonificacion(props_zonificacion: boolean): void
    openCrearNotaDialog(data: Record<string, any>): void
    openEditarNotaDialog(data: Record<string, any>): void
    mapa: IMapas
    zoom: number
    center: LatLngTuple
    parcela: IParcela
    product: string
    bounds: LatLngTuple[]
    sectores: Record<string, LatLngTuple[]>
    zonificacion: boolean
    loading_zonificador: boolean
    zonificaciones: IZona[]
    zonificacion_selected: string
    props_zonificacion: boolean
    section: ISections
    nota: Record<string, any>
    usuario: string
    notas_campo: boolean
    editar_nota: Record<string, any>
    crear_nota: Record<string, any>
    idioma: string
}

interface Istate {
    onParcela: boolean
    value: number
    pixel: any
    pixelListo: boolean
    cargandoZonificador: boolean
    zonaLista: boolean
    vertical: boolean
    cambiando: boolean
    mostrar: boolean
    location: LatLngTuple | null
    rulerPoints: LatLngTuple[]
    areaPoints: LatLngTuple[]
    clickedRuler: boolean
    clickedArea: boolean
    clickedNota: boolean
    unitsRuler: number
    unitsArea: number
    pixelPopup: boolean
    cambioPopup: boolean
    notas: Record<string, string|number>[]
    text: Record<string, string>,
    dragging: boolean,
    moving: boolean
}

const unitsRuler: Record<number, string> = {
    0: 'm',
    1: 'km'
}

const unitsArea: Record<number, string> = {
    0: 'm²',
    1: 'ha'
}

class Mapa extends React.Component<IProps, Istate> {

    state:Istate = {
        onParcela: false,
        value: 0,
        pixel: null,
        pixelListo: true,
        cargandoZonificador: false,
        zonaLista: true,
        vertical: window.matchMedia("(orientation: portrait)").matches,
        cambiando: false,
        mostrar: true,
        location: null,
        rulerPoints: [],
        areaPoints: [],
        clickedRuler: false,
        clickedArea: false,
        clickedNota: false,
        unitsRuler: 0,
        unitsArea: 0,
        pixelPopup: false,
        cambioPopup: false,
        notas: [] as Record<string, string|number>[],
        text: texts[this.props.idioma],
        dragging: false,
        moving: false
    }

    componentDidMount() {
        if ("geolocation" in navigator) {
            this.getLocation()
        }
        axios.get(
            config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
            {auth: {
                    username: `${userService.getUser()}`,
                    password: `${userService.getPass()}`
                }})
            .then((res) => {
                this.setState({notas: res.data.data as Record<string, string|number>[]})
            })
            .catch(() => {})
    }

    // shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
    //     if (this.props.idioma !== nextProps.idioma) {
    //         this.setState({
    //             text: texts[nextProps.idioma]
    //         })
    //     }
    //
    //     if (nextProps.product.length === 0 && this.state.pixelPopup) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (nextProps.product.length !== 0 && nextProps.product.split(',')[2] === "rgb" && this.state.pixelPopup) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (!this.state.clickedNota && nextState.clickedNota) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (
    //         nextProps.product.length !== 0 &&
    //         nextProps.product.split(',')[2] !== "rgb" && !this.state.pixelPopup &&
    //         this.state.clickedNota && !nextState.clickedNota
    //     ) {
    //         this.setState({pixelPopup: true})
    //     }
    //
    //
    //     if ((Object.keys(this.props.editar_nota).length > 0 && Object.keys(nextProps.editar_nota).length === 0) ||
    //         (Object.keys(this.props.crear_nota).length > 0 && Object.keys(nextProps.crear_nota).length === 0)) {
    //         axios.get(
    //             config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
    //             {auth: {
    //                     username: `${userService.getUser()}`,
    //                     password: `${userService.getPass()}`
    //                 }})
    //             .then((res) => {
    //                 this.setState({notas: res.data.data as Record<string, string|number>[]})
    //             })
    //             .catch(() => {})
    //     }
    //
    //     if (!this.props.notas_campo && nextProps.notas_campo) {
    //         axios.get(
    //             config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
    //             {auth: {
    //                     username: `${userService.getUser()}`,
    //                     password: `${userService.getPass()}`
    //                 }})
    //             .then((res) => {
    //                 this.setState({notas: res.data.data as Record<string, string|number>[]})
    //             })
    //             .catch(() => {})
    //     }
    //
    //     if (this.props.product.length === 0 && nextProps.product.length !== 0 && !this.state.clickedArea && !this.state.clickedRuler && !this.state.clickedNota) {
    //         this.setState({pixelPopup: true})
    //     }
    //     if (this.props.product.length !== 0 && nextProps.product.length === 0) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (!this.state.clickedRuler && nextState.clickedRuler) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (this.state.clickedRuler && !nextState.clickedRuler) {
    //         this.setState({rulerPoints: []})
    //         if (nextProps.product.length !== 0) {
    //             this.setState({pixelPopup: true})
    //         }
    //     }
    //
    //     if (!this.state.clickedArea && nextState.clickedArea) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (this.state.clickedArea && !nextState.clickedArea) {
    //         this.setState({areaPoints: []})
    //         if (nextProps.product.length !== 0) {
    //             this.setState({pixelPopup: true})
    //         }
    //     }
    //
    //     if (!this.state.clickedNota && nextState.clickedNota) {
    //         this.setState({pixelPopup: false})
    //     }
    //
    //     if (this.state.clickedNota && !nextState.clickedNota) {
    //         if (nextProps.product.length !== 0) {
    //             this.setState({pixelPopup: true})
    //         }
    //     }
    //
    //     if (this.state.pixelPopup !== nextState.pixelPopup) {
    //         this.setState({cambioPopup: true})
    //         setTimeout(() => this.setState({cambioPopup: false}), 100)
    //     }
    //
    //     if (this.props.product !== nextProps.product && nextProps.product.length !== 0) {
    //         this.setState({
    //             value: 0,
    //             pixel: null
    //         })
    //
    //         let fuente = ""
    //         const parcela = this.props.parcela.id
    //         const fecha = (nextProps.product.split(',')[1]).split('/').reverse().join('-')
    //         let indice = ""
    //
    //         if (["Humedad"].includes(nextProps.product.split(',')[2])) {
    //             fuente = 'Humedad'
    //             indice = 'humedad'
    //         }
    //         if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(nextProps.product.split(',')[2])) {
    //             fuente = nextProps.product.split(',')[2]
    //             indice = 'ETc_24'
    //         }
    //         if (nextProps.product.split(',')[0]==="satelite" && nextProps.product.split(',')[2] === "lst") {
    //             fuente = 'landsat_8'
    //             indice = nextProps.product.split(',')[2]
    //         }
    //         if (nextProps.product.split(',')[0]==="satelite" && nextProps.product.split(',')[2] !== "lst") {
    //             fuente = 'sentinel_2a'
    //             indice = nextProps.product.split(',')[2]
    //         }
    //         if (nextProps.product.split(',')[0]==="dron") {
    //             fuente = 'rpas'
    //             indice = nextProps.product.split(',')[2]
    //         }
    //
    //         const url: string = config.url+`/get/bounds?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}`
    //         axios.get(
    //             url,
    //             {auth: {
    //                     username: `${userService.getUser()}`,
    //                     password: `${userService.getPass()}`
    //                 }})
    //             .then((res) => {
    //                 this.props.setBounds(res.data as LatLngTuple[])
    //             })
    //             .catch(() => {})
    //     }
    //
    //     if (this.props.zonificacion_selected !== nextProps.zonificacion_selected && nextProps.zonificacion_selected.length >0) {
    //         this.setState({zonaLista: false})
    //         setTimeout(() => this.setState({zonaLista: true}), 1)
    //     }
    //
    //     if (this.state.pixel !== nextState.pixel && nextState.pixel !== {}) {
    //         this.setState({pixelListo: false})
    //         setTimeout(() => this.setState({pixelListo: true}), 1)
    //     }
    //
    //     if (this.props.product !== nextProps.product) {
    //         this.setState({mostrar: false})
    //         setTimeout(() => this.setState({mostrar: true}), 1)
    //     }
    //
    //     return true
    // }

    shouldComponentUpdate(nextProps: Readonly<IProps>, nextState: Readonly<Istate>, nextContext: any): boolean {
        if (this.props.idioma !== nextProps.idioma) {
            this.setState({
                text: texts[nextProps.idioma]
            })
        }

        if (nextProps.product.length === 0 && this.state.pixelPopup) {
            this.setState({pixelPopup: false})
        }

        if (nextProps.product.length !== 0 && nextProps.product.split(',')[2] === "rgb" && this.state.pixelPopup) {
            this.setState({pixelPopup: false})
        }

        if (!this.state.clickedNota && nextState.clickedNota) {
            this.setState({pixelPopup: false})
        }

        if (this.props.product.split(',')[2] === "rgb" &&
            nextProps.product.length !== 0 && nextProps.product.split(',')[2] !== "rgb") {
            this.setState({pixelPopup: true})
        }

        if (
            nextProps.product.length !== 0 &&
            nextProps.product.split(',')[2] !== "rgb" && !this.state.pixelPopup &&
            this.state.clickedNota && !nextState.clickedNota
        ) {
            this.setState({pixelPopup: true})
        }


        if ((Object.keys(this.props.editar_nota).length > 0 && Object.keys(nextProps.editar_nota).length === 0) ||
            (Object.keys(this.props.crear_nota).length > 0 && Object.keys(nextProps.crear_nota).length === 0)) {
            axios.get(
                config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.setState({notas: res.data.data as Record<string, string|number>[]})
                })
                .catch(() => {})
        }

        if (!this.props.notas_campo && nextProps.notas_campo) {
            axios.get(
                config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.setState({notas: res.data.data as Record<string, string|number>[]})
                })
                .catch(() => {})
        }

        if (this.props.product.length === 0 && nextProps.product.length !== 0 && !this.state.clickedArea && !this.state.clickedRuler && !this.state.clickedNota) {
            this.setState({pixelPopup: true})
        }
        if (this.props.product.length !== 0 && nextProps.product.length === 0) {
            this.setState({pixelPopup: false})
        }

        if (!this.state.clickedRuler && nextState.clickedRuler) {
            this.setState({pixelPopup: false})
        }

        if (this.state.clickedRuler && !nextState.clickedRuler) {
            this.setState({rulerPoints: []})
            if (nextProps.product.length !== 0) {
                this.setState({pixelPopup: true})
            }
        }

        if (!this.state.clickedArea && nextState.clickedArea) {
            this.setState({pixelPopup: false})
        }

        if (this.state.clickedArea && !nextState.clickedArea) {
            this.setState({areaPoints: []})
            if (nextProps.product.length !== 0) {
                this.setState({pixelPopup: true})
            }
        }

        if (!this.state.clickedNota && nextState.clickedNota) {
            this.setState({pixelPopup: false})
        }

        if (this.state.clickedNota && !nextState.clickedNota) {
            if (nextProps.product.length !== 0) {
                this.setState({pixelPopup: true})
            }
        }

        if (this.state.pixelPopup !== nextState.pixelPopup) {
            this.setState({cambioPopup: true})
            setTimeout(() => this.setState({cambioPopup: false}), 100)
        }

        if (this.props.product !== nextProps.product && nextProps.product.length !== 0) {
            this.setState({
                value: 0,
                pixel: null
            })

            let fuente = ""
            const parcela = this.props.parcela.id
            const fecha = (nextProps.product.split(',')[1]).split('/').reverse().join('-')
            let indice = ""

            if (["Humedad"].includes(nextProps.product.split(',')[2])) {
                fuente = 'Humedad'
                indice = 'humedad'
            }
            if (["dsm"].includes(nextProps.product.split(',')[2])) {
                fuente = 'DSM'
                indice = 'dsm'
            }
            if (["clay"].includes(nextProps.product.split(',')[2])) {
                fuente = 'Clay'
                indice = 'clay'
            }
            if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(nextProps.product.split(',')[2])) {
                fuente = nextProps.product.split(',')[2]
                indice = 'ETc_24'
            }
            if (nextProps.product.split(',')[0]==="satelite" && nextProps.product.split(',')[2] === "lst") {
                fuente = 'landsat_8'
                indice = nextProps.product.split(',')[2]
            }
            if (nextProps.product.split(',')[0]==="satelite" && nextProps.product.split(',')[2] !== "lst") {
                fuente = 'sentinel_2a'
                indice = nextProps.product.split(',')[2]
            }
            if (nextProps.product.split(',')[0]==="dron") {
                fuente = 'rpas'
                indice = nextProps.product.split(',')[2]
            }

            const url: string = config.url+`/get/bounds?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}`

            axios.get(
                url,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.props.setBounds(res.data as LatLngTuple[])
                })
                .catch(() => {})
        }

        if (this.props.zonificacion_selected !== nextProps.zonificacion_selected && nextProps.zonificacion_selected.length >0) {
            this.setState({zonaLista: false})
            setTimeout(() => this.setState({zonaLista: true}), 1)
        }

        if (this.state.pixel !== nextState.pixel && nextState.pixel !== {}) {
            this.setState({pixelListo: false})
            setTimeout(() => this.setState({pixelListo: true}), 1)
        }

        if (this.props.product !== nextProps.product) {
            this.setState({mostrar: false})
            setTimeout(() => this.setState({mostrar: true}), 1)
        }

        return true
    }

    setStylePixel(feature: any, layer: any) {
        layer.options.color = 'rgb(0,0,0)'
        layer.options.fillColor = 'rgb(255,255,255,0)'
    }

    handleClic = (latlon: any) => {
        if (this.state.onParcela && this.state.clickedNota) {
            this.props.openCrearNotaDialog({
                coords: latlon as LatLngTuple,
                parcela: this.props.parcela.id
            })
        }

        if (this.state.clickedRuler && !this.state.dragging) {
            const rulerPoints = [...this.state.rulerPoints]
            rulerPoints.push([latlon.lat, latlon.lng])

            let ok_poligon = []
            for (let i = 0; i < rulerPoints.length - 1; i++) {
                let repetido = false
                for (let j = i+1; j < rulerPoints.length; j++) {
                    if (rulerPoints[i][0] == rulerPoints[j][0] && rulerPoints[i][1] == rulerPoints[j][1]) {
                        repetido = true
                    }
                }
                if (!repetido) ok_poligon.push(rulerPoints[i])
            }
            ok_poligon.push(rulerPoints[rulerPoints.length-1])

            this.setState({rulerPoints: ok_poligon})
        }

        if (this.state.clickedArea && !this.state.dragging) {
            const areaPoints = [...this.state.areaPoints]
            areaPoints.push([latlon.lat, latlon.lng])

            let ok_poligon = []
            for (let i = 0; i < areaPoints.length - 1; i++) {
                let repetido = false
                for (let j = i+1; j < areaPoints.length; j++) {
                    if (areaPoints[i][0] == areaPoints[j][0] && areaPoints[i][1] == areaPoints[j][1]) {
                        repetido = true
                    }
                }
                if (!repetido) ok_poligon.push(areaPoints[i])
            }
            ok_poligon.push(areaPoints[areaPoints.length-1])

            this.setState({areaPoints: ok_poligon})
        }

        if (this.state.onParcela && this.props.product.length > 0 && !this.state.clickedRuler && !this.state.clickedArea && !this.state.clickedNota) {

            let fuente = ""
            const parcela = this.props.parcela.id
            const fecha = (this.props.product.split(',')[1]).split('/').reverse().join('-')
            let indice = ""
            let resol = ''

            if (["Humedad"].includes(this.props.product.split(',')[2])) {
                fuente = 'Humedad'
                indice = 'humedad'
                resol = '10m'
            }
            if (["dsm"].includes(this.props.product.split(',')[2])) {
                fuente = 'DSM'
                indice = 'dsm'
                resol = '1m'
            }
            if (["clay"].includes(this.props.product.split(',')[2])) {
                fuente = 'Clay'
                indice = 'clay'
                resol = '10m'
            }
            if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(this.props.product.split(',')[2])) {
                fuente = this.props.product.split(',')[2]
                indice = 'ETc_24'
                if (this.props.product.split(',')[2] === "ETc_low") {
                    resol = '10m'
                } else {
                    resol = '1m'
                }
            }
            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] === "lst") {
                fuente = 'landsat_8'
                indice = this.props.product.split(',')[2]
                resol = '10m'
            }
            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] !== "lst") {
                fuente = 'sentinel_2a'
                indice = this.props.product.split(',')[2]
                resol = '10m'
            }
            if (this.props.product.split(',')[0]==="dron") {
                fuente = 'rpas'
                indice = this.props.product.split(',')[2]
                if (!['lst', 'rgb', 'ndvi'].includes(indice)){
                    resol = '1m'
                } else {
                    resol = '1m'
                }
            }

            const url = config.url+`/get/pixel?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}&resol=${resol}&lng=${latlon.lng}&lat=${latlon.lat}`
            axios.get(
                url,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    let value = res.data.value
                    if (indice === 'lst') value -= 273.15
                    if (indice === 'dsm') value = Math.round(res.data.value)
                    this.setState({
                        value: Math.round(value*100)/100,
                        pixel: {
                            "type": "Feature",
                            "properties": {},
                            "geometry": {
                                "type": "Polygon",
                                "coordinates": [res.data.coords]
                            }
                        }
                    })
                })
                .catch(() => {})
        } else {
            this.setState({
                pixel: null
            })
        }
    }


    handleZonificador = () => {
        if (this.props.zonificacion) {
            return
        } else {
            this.setState({cargandoZonificador: true})

            let fuente = ""
            const parcela = this.props.parcela.id
            const fecha = (this.props.product.split(',')[1]).split('/').reverse().join('-')
            let indice = ""
            let resol = 2

            if (["Humedad"].includes(this.props.product.split(',')[2])) {
                fuente = 'Humedad'
                indice = 'humedad'
                resol = 2
            }
            if (["dsm"].includes(this.props.product.split(',')[2])) {
                fuente = 'DSM'
                indice = 'dsm'
                resol = 1
            }
            if (["clay"].includes(this.props.product.split(',')[2])) {
                fuente = 'Clay'
                indice = 'clay'
                resol = 2
            }
            if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(this.props.product.split(',')[2])) {
                fuente = this.props.product.split(',')[2]
                indice = 'ETc_24'
                if (this.props.product.split(',')[2] === "ETc_low") {
                    resol = 2
                } else {
                    resol = 1
                }
            }
            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] === "lst") {
                fuente = 'landsat_8'
                indice = this.props.product.split(',')[2]
                resol = 2
            }
            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] !== "lst") {
                fuente = 'sentinel_2a'
                indice = this.props.product.split(',')[2]
                resol = 2
            }
            if (this.props.product.split(',')[0]==="dron") {
                fuente = 'rpas'
                indice = this.props.product.split(',')[2]
                resol = 1
            }

            const url = config.url+`/calcula/histograma?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}&resol=${resol}`
            axios.get(
                url,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.props.setHistograma(res.data['histograma'])
                    this.setState({cargandoZonificador: false})
                    this.props.setZonificacion(true)
                })
                .catch(() => {
                    this.setState({cargandoZonificador: false})
                    this.props.notify({message: this.state.text["0"], variant: 'error'})
                })
        }
    }

    handlePropsZonificador = () => {
        if (this.props.props_zonificacion) {
            return
        } else {
            this.setState({cargandoZonificador: true})

            const fuente = this.props.zonificacion_selected.split(',')[0]
            const parcela = this.props.zonificacion_selected.split(',')[1]
            const fecha = this.props.zonificacion_selected.split(',')[2]
            const indice = this.props.zonificacion_selected.split(',')[3]

            let resol = 2
            if (["ETc_hibrida", "rpas"].includes(fuente)) resol = 1

            const url = config.url+`/calcula/histograma?fuente=${fuente}&parcela=${parcela}&fecha=${fecha}&indice=${indice}&resol=${resol}`
            axios.get(
                url,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.props.setHistograma(res.data['histograma'])
                    this.props.setPropsZonificacion(true)
                    this.setState({cargandoZonificador: false})
                })
                .catch(() => {
                    this.setState({cargandoZonificador: false})
                    this.props.notify({message: this.state.text["0"], variant: 'error'})
                })
        }
    }

    renderZonificacion = () => {
        let zona = {} as IZona
        for (const element of this.props.zonificaciones) {
            if (element.id === this.props.zonificacion_selected) {
                zona = element
            }
        }
        return (
            <FeatureGroup>
                {Object.keys(zona.poligonos).map(i =>
                    <Polygon
                        key={zona.poligonos[parseInt(i)].id}
                        positions={zona.poligonos[parseInt(i)].lat_lon_coords}
                        color={zona.poligonos[parseInt(i)].color}
                        fillColor={zona.poligonos[parseInt(i)].color}
                        fillOpacity={1}
                        onmouseover={() => this.setState({onParcela: true})}
                        onmouseout={() => this.setState({onParcela: false})}
                    />
                )}
            </FeatureGroup>
        )
    }


    getRulerDistance = (index: number): number => {
        let distance = 0
        if (index < 2) return distance
        for (let i = 0; i < index - 1; i++) {
            distance += geolib.getPreciseDistance(
                {latitude: this.state.rulerPoints[i][0], longitude: this.state.rulerPoints[i][1]},
                {latitude: this.state.rulerPoints[i+1][0], longitude: this.state.rulerPoints[i+1][1]},
                0.01
            )
        }
        if (this.state.unitsRuler === 0) {
            return Math.round(distance*100)/100
        } else if (this.state.unitsRuler === 1) {
            return Math.round(distance/10)/100
        } else {
            return 0
        }

    }

    generatesCartesiansystem = (points: LatLngTuple[]) => {
        let coords: number[][] = []
        if (points.length === 0) return coords
        coords.push([0,0])
        if (points.length === 1) return coords

        let a = 0
        let point = 0
        for (let i = 1; i < points.length; i++) {
            let d = geolib.getPreciseDistance(
                {latitude: points[0][0], longitude: points[0][1]},
                {latitude: points[i][0], longitude: points[i][1]},
                0.01
            )
            if (d > a) {
                a = d
                point = i
            }
        }
        let b = 0
        let c = 0
        let theta = 0
        for (let i = 1; i < points.length; i++) {
            if (i === point) {
                coords.push([a, 0])
            } else {
                b = geolib.getPreciseDistance(
                    {latitude: points[0][0], longitude: points[0][1]},
                    {latitude: points[i][0], longitude: points[i][1]},
                    0.01
                )
                c = geolib.getPreciseDistance(
                    {latitude: points[point][0], longitude: points[point][1]},
                    {latitude: points[i][0], longitude: points[i][1]},
                    0.01
                )
                if (i < point) {
                    theta = Math.acos((a**2 + b**2 - c**2)/(2*a*b))
                } else {
                    theta = -Math.acos((a**2 + b**2 - c**2)/(2*a*b))
                }
                coords.push([
                    b*Math.cos(theta),
                    b*Math.sin(theta)
                ])
            }
        }
        return coords
    }

    isSimpleSurface = (points: LatLngTuple[]): boolean => {
        if (points.length < 4) return true
        let areaPoints = []
        for (let point of points) {
            areaPoints.push([point[0]*1000, point[1]*1000])
        }
        areaPoints.push([points[0][0]*1000, points[0][1]*1000])

        let ok_points = [] as any
        ok_points.push(areaPoints[0])
        for (let point of areaPoints) {
            if (ok_points[ok_points.length-1][0] === point[0] && ok_points[ok_points.length-1][1] === point[1]) continue
            ok_points.push(point)
        }

        let poly = {
            "type": "Feature",
            "geometry": {
                "type": "Polygon",
                "coordinates": [ok_points]
            }
        };

        let result = simplepolygon(poly)
        return result.features.length === 1;
    }

    getAreaSurface = (): number|string => {
        if (this.state.areaPoints.length < 3) return 0

        if (!this.isSimpleSurface(this.state.areaPoints)) return "-"

        const c = this.generatesCartesiansystem(this.state.areaPoints)
        let coords = []
        for (let coord of c) {
            coords.push({x: coord[1], y: coord[0]})
        }

        const area = THREE.ShapeUtils.area(coords)

        if (this.state.unitsArea === 0) {
            return Math.sign(area)*Math.round(area*100)/100
        } else if (this.state.unitsArea === 1) {
            return Math.sign(area)*Math.round(area/100)/100
        } else {
            return 0
        }
    }

    getAreaPerimeter = (): number => {
        let distance = 0
        if (this.state.areaPoints.length < 3) return distance
        for (let i = 0; i < this.state.areaPoints.length - 1; i++) {

            distance += geolib.getPreciseDistance(
                {latitude: this.state.areaPoints[i][0], longitude: this.state.areaPoints[i][1]},
                {latitude: this.state.areaPoints[i+1][0], longitude: this.state.areaPoints[i+1][1]},
                0.01
            )
        }
        distance += geolib.getPreciseDistance(
            {latitude: this.state.areaPoints[this.state.areaPoints.length - 1][0], longitude: this.state.areaPoints[this.state.areaPoints.length - 1][1]},
            {latitude: this.state.areaPoints[0][0], longitude: this.state.areaPoints[0][1]},
            0.01
        )
        if (this.state.unitsRuler === 0) {
            return Math.round(distance*100)/100
        } else if (this.state.unitsRuler === 1) {
            return Math.round(distance/10)/100
        } else {
            return 0
        }
    }

    updateNotePosition = (id: string, lat: number, lng: number) => {
        if (pointInPolygon([lat, lng], this.props.parcela.lat_lon)) {
            const data = {
                id: id,
                lat: lat,
                lng: lng
            }
            axios.post(
                config.url+'/edit/note',
                data,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }
                })
                .then(() => {
                    axios.get(
                        config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
                        {auth: {
                                username: `${userService.getUser()}`,
                                password: `${userService.getPass()}`
                            }})
                        .then((res) => {
                            this.setState({notas: res.data.data as Record<string, string|number>[]})
                        })
                        .catch(() => {})
                })
                .catch(() => {})
        } else {
            axios.get(
                config.url+`/get/notes?user=${userService.getUser()}&parcela=${this.props.parcela.id}`,
                {auth: {
                        username: `${userService.getUser()}`,
                        password: `${userService.getPass()}`
                    }})
                .then((res) => {
                    this.setState({notas: res.data.data as Record<string, string|number>[]})
                })
                .catch(() => {})
        }

    }


    succes = (pos: any) => {
        const crd = pos.coords;
        this.setState({location: [crd.latitude, crd.longitude] as LatLngTuple})
    }

    error = (err: any) => {
    }

    delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    getLocation = async () => {
        const options = {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0
        };
        while (this.props.section === 'visualizador') {
            await this.delay(5000);
            navigator.geolocation.getCurrentPosition(this.succes, this.error, options)
        }
    }

    render() {
        const doOnOrientationChange = () => {
            if (!this.state.cambiando) {
                this.setState({cambiando: true, vertical: !this.state.vertical})
                setTimeout(() => this.setState({cambiando: false}), 100)
            }
        }

        window.addEventListener("orientationchange", function() {
            doOnOrientationChange()
        }, false)

        let image_url = ""
        if (this.props.product.length > 0) {
            if (["Humedad"].includes(this.props.product.split(',')[2])) {
                image_url = config.url+'/static/visualizador/Humedad'+'/'+this.props.parcela.id+'/'+(this.props.product.split(',')[1])+'/humedad.png'
            }
            if (["ETc_hibrida", "ETc_high", "ETc_low"].includes(this.props.product.split(',')[2])) {
                image_url = config.url+'/static/visualizador/'+this.props.product.split(',')[2]+'/'+this.props.parcela.id+'/'+(this.props.product.split(',')[1])+'/ETc_24.png'
            }
            if (this.props.product.split(',')[2] === "dsm") {
                image_url = config.url+'/static/visualizador/DSM/'+this.props.parcela.id+'/dsm.png'
            }
            if (this.props.product.split(',')[2] === "clay") {
                image_url = config.url+'/static/visualizador/Clay/'+this.props.parcela.id+'/clay.png'
            }
            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] === "lst") {
                image_url = config.url+'/static/visualizador/landsat_8'+'/'+this.props.parcela.id+'/'+(this.props.product.split(',')[1])+'/lst.png'
            }
            if (this.props.product.split(',')[0]==="satelite" && this.props.product.split(',')[2] !== "lst") {
                image_url = config.url+'/static/visualizador/sentinel_2a'+'/'+this.props.parcela.id+'/'+(this.props.product.split(',')[1])+'/'+this.props.product.split(',')[2]+'.png'
            }
            if (this.props.product.split(',')[0]==="dron") {
                image_url = config.url+'/static/visualizador/rpas'+'/'+this.props.parcela.id+'/'+(this.props.product.split(',')[1])+'/'+this.props.product.split(',')[2]+'.png'
            }
        }

        return (
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    width: '100%',
                    height: '100%'
                }}
            >
                <Map
                    center={this.props.center}
                    zoom={this.props.zoom}
                    zoomControl={false}
                    maxZoom={25}
                    style={{
                        width: '100%',
                        height: '100%',
                        zIndex: 1
                    }}
                    onmoveend={(e) => {
                        this.props.setZoom(e.target.getZoom())
                        this.props.setCenter([e.target.getCenter().lat,e.target.getCenter().lng])
                    }}
                    ondragstart={() => {
                        this.setState({moving: true})
                    }}
                    onzoomstart={() => {
                        this.setState({moving: true})
                    }}
                    ondragend={() => {
                        setTimeout(() => this.setState({moving: false}), 500)
                    }}
                    onzoomend={() => {
                        setTimeout(() => this.setState({moving: false}), 100)
                    }}
                    onclick={(e) => {
                        if (!this.state.moving) this.handleClic(e.latlng)
                    }}
                >
                    {this.props.zoom <= 21 &&
                        <TileLayer url={"http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"}/>
                    }
                    {/*<TileLayer url={"https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"}/>*/}

                    {this.props.zonificacion_selected.length !== 0 && this.state.zonaLista && this.renderZonificacion()}

                    {this.state.location !== null &&
                        <Marker
                            draggable={false}
                            position={this.state.location}
                            icon={location_icon}
                        />
                    }

                    {!this.state.cambioPopup && this.state.zonaLista &&
                    <FeatureGroup>
                        <Polygon
                            key={this.props.parcela.id}
                            positions={this.props.parcela.lat_lon}
                            color={'rgb(255,255,255)'}
                            fillColor={'rgb(255,255,255,0)'}
                            onmouseover={() => this.setState({onParcela: true})}
                            onmouseout={() => this.setState({onParcela: false})}
                            onclick={(e) => {
                                if (!this.state.clickedRuler && !this.state.clickedArea && !this.state.clickedNota && !this.state.moving) this.handleClic(e.latlng)
                            }}
                        />
                        {this.state.pixelPopup && this.props.product.split(',')[2]!=="rgb" && !this.state.moving &&
                            <Popup>
                                <Typography style={{fontWeight: "bold"}}>
                                    {Math.round(this.state.value * 100) / 100}
                                </Typography>
                            </Popup>
                        }
                    </FeatureGroup>
                    }

                    {!this.state.cambioPopup && this.state.zonaLista &&
                    <FeatureGroup>
                        {Object.keys(this.props.sectores).map((id) =>
                            <Polygon
                                key={id}
                                positions={this.props.sectores[id]}
                                color={'rgb(31,102,144)'}
                                fillColor={'rgb(0,155,255,0)'}
                                onmouseover={() => this.setState({onParcela: true})}
                                onmouseout={() => this.setState({onParcela: false})}
                                onclick={(e) => {
                                    if (!this.state.clickedRuler && !this.state.clickedArea && !this.state.clickedNota && !this.state.moving) this.handleClic(e.latlng)
                                }}
                            />
                        )}
                        {this.state.pixelPopup && this.props.product.split(',')[2]!=="rgb" && !this.state.moving &&
                            <Popup>
                                <Typography style={{fontWeight: "bold"}}>
                                    {Math.round(this.state.value * 100) / 100}
                                </Typography>
                            </Popup>
                        }
                    </FeatureGroup>
                    }

                    {this.state.rulerPoints.length > 0 &&
                        <Polygon
                            positions={[
                                [90, -180],
                                [90, 180],
                                [-90, 180],
                                [-90, -180]
                            ]}
                            color={'rgb(0,0,0,0)'}
                            fillColor={'rgb(0,0,0,0)'}
                            onclick={(e) => {
                                if (!this.state.moving) this.handleClic(e.latlng)
                            }}

                        >

                            <Polyline
                                positions={this.state.rulerPoints}
                                color={'#dcc32d'}
                            />
                            {this.state.rulerPoints.map((point: LatLngTuple, index) =>
                                <Marker
                                    key={index}
                                    draggable={true}
                                    position={point}
                                    icon={editable_icon}
                                    ondragstart={() => this.setState({dragging: true})}
                                    ondragend={e => {
                                        let poligon = [...this.state.rulerPoints] as LatLngTuple[]
                                        poligon[index] = [e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple

                                        let ok_poligon = []
                                        for (let i = 0; i < poligon.length - 1; i++) {
                                            let repetido = false
                                            for (let j = i+1; j < poligon.length; j++) {
                                                if (poligon[i][0] == poligon[j][0] && poligon[i][1] == poligon[j][1]) {
                                                    repetido = true
                                                }
                                            }
                                            if (!repetido) ok_poligon.push(poligon[i])
                                        }
                                        ok_poligon.push(poligon[poligon.length-1])

                                        this.setState({rulerPoints: ok_poligon})
                                        setTimeout(() => this.setState({dragging: false}), 100)
                                    }}
                                >
                                    {!this.state.moving &&
                                        <Popup>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "fit-content",
                                                    height: "fit-content"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "space-between",
                                                        width: '100%'
                                                    }}
                                                >
                                                    {Object.keys(unitsRuler).map(el =>
                                                        <Paper
                                                            elevation={2}
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                width: 30,
                                                                height: 30,
                                                                borderRadius: 15,
                                                                cursor: "pointer",
                                                                backgroundColor: this.state.unitsRuler === parseInt(el as string) ? '#80ED99'
                                                                    :
                                                                    '#ddd'
                                                            }}
                                                            onClick={() => {
                                                                this.setState({unitsRuler: parseInt(el as string)})
                                                            }}
                                                        >
                                                            <Typography
                                                                style={{
                                                                    fontFamily: "Poppins",
                                                                    fontSize: 16
                                                                }}
                                                            >
                                                                {unitsRuler[parseInt(el as string)]}
                                                            </Typography>
                                                        </Paper>
                                                    )}

                                                </div>

                                                <Typography
                                                    style={{
                                                        fontFamily: "Poppins",
                                                        fontWeight: "bold",
                                                        fontSize: 18
                                                    }}
                                                >
                                                    {this.getRulerDistance(index + 1)} {unitsRuler[this.state.unitsRuler]}
                                                </Typography>


                                                <Paper
                                                    elevation={2}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: 20,
                                                        backgroundColor: "#ccc",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => {
                                                        this.setState({rulerPoints: []})
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            marginLeft: 0,
                                                            height: 20
                                                        }}
                                                        src={CleanIcon}
                                                        alt="ruler img"
                                                    />
                                                </Paper>
                                            </div>
                                        </Popup>
                                    }
                                </Marker>
                            )}
                        </Polygon>
                    }

                    {this.state.areaPoints.length > 0 &&
                        <Polygon
                            positions={[
                                [90, -180],
                                [90, 180],
                                [-90, 180],
                                [-90, -180]
                            ]}
                            color={'rgb(0,0,0,0)'}
                            fillColor={'rgb(0,0,0,0)'}
                            onclick={(e) => {
                                if (!this.state.moving) this.handleClic(e.latlng)
                            }}
                        >

                            <Polygon
                                positions={this.state.areaPoints}
                                color={this.isSimpleSurface(this.state.areaPoints)? '#dcc32d' : '#bf3636'}
                            />
                            {this.state.areaPoints.map((point: LatLngTuple, index) =>
                                <Marker
                                    key={index}
                                    draggable={true}
                                    position={point}
                                    icon={this.isSimpleSurface(this.state.areaPoints)? editable_icon : delete_icon}
                                    ondragstart={() => this.setState({dragging: true})}
                                    ondragend={e => {
                                        let poligon = [...this.state.areaPoints] as LatLngTuple[]
                                        poligon[index] = [e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple

                                        if (index === 0 && this.state.areaPoints[0][0] === this.state.areaPoints[this.state.areaPoints.length-1][0] ) {
                                            poligon[this.state.areaPoints.length-1] = [e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple
                                        }

                                        if (index === this.state.areaPoints.length-1 && this.state.areaPoints[0][0] === this.state.areaPoints[this.state.areaPoints.length-1][0] ) {
                                            poligon[0] = [e.target.getLatLng().lat, e.target.getLatLng().lng] as LatLngTuple
                                        }

                                        let ok_poligon = []
                                        for (let i = 0; i < poligon.length - 1; i++) {
                                            let repetido = false
                                            for (let j = i+1; j < poligon.length; j++) {
                                                if (poligon[i][0] == poligon[j][0] && poligon[i][1] == poligon[j][1]) {
                                                    repetido = true
                                                }
                                            }
                                            if (!repetido) ok_poligon.push(poligon[i])
                                        }
                                        ok_poligon.push(poligon[poligon.length-1])

                                        this.setState({areaPoints: ok_poligon})
                                        setTimeout(() => this.setState({dragging: false}), 100)

                                    }}
                                >
                                    {!this.state.moving &&
                                        <Popup>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "fit-content",
                                                    height: "fit-content"
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: "fit-content",
                                                        height: "fit-content"
                                                    }}
                                                >

                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "fit-content",
                                                            height: "fit-content",
                                                            marginRight: 40
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{
                                                                fontFamily: "Poppins",
                                                                fontWeight: "bold",
                                                                fontSize: 16
                                                            }}
                                                        >
                                                            {this.state.text["1"]}
                                                        </Typography>

                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                width: '100%'
                                                            }}
                                                        >
                                                            {Object.keys(unitsArea).map(el =>
                                                                <Paper
                                                                    elevation={2}
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: 30,
                                                                        height: 30,
                                                                        borderRadius: 15,
                                                                        cursor: "pointer",
                                                                        backgroundColor: this.state.unitsArea === parseInt(el as string) ? '#80ED99' : '#ddd'
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({unitsArea: parseInt(el as string)})
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        style={{
                                                                            fontFamily: "Poppins",
                                                                            fontSize: 16
                                                                        }}
                                                                    >
                                                                        {unitsArea[parseInt(el as string)]}
                                                                    </Typography>
                                                                </Paper>
                                                            )}

                                                        </div>

                                                        <Typography
                                                            style={{
                                                                fontFamily: "Poppins",
                                                                fontWeight: "bold",
                                                                fontSize: 18
                                                            }}
                                                        >
                                                            {this.getAreaSurface()} {unitsArea[this.state.unitsArea]}
                                                        </Typography>
                                                    </div>


                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            width: "fit-content",
                                                            height: "fit-content"
                                                        }}
                                                    >
                                                        <Typography
                                                            style={{
                                                                fontFamily: "Poppins",
                                                                fontWeight: "bold",
                                                                fontSize: 16
                                                            }}
                                                        >
                                                            {this.state.text["2"]}
                                                        </Typography>

                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                                width: '100%'
                                                            }}
                                                        >
                                                            {Object.keys(unitsRuler).map(el =>
                                                                <Paper
                                                                    elevation={2}
                                                                    style={{
                                                                        display: "flex",
                                                                        flexDirection: "row",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        width: 30,
                                                                        height: 30,
                                                                        borderRadius: 15,
                                                                        cursor: "pointer",
                                                                        backgroundColor: this.state.unitsRuler === parseInt(el as string) ? '#80ED99' : '#ddd'
                                                                    }}
                                                                    onClick={() => {
                                                                        this.setState({unitsRuler: parseInt(el as string)})
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        style={{
                                                                            fontFamily: "Poppins",
                                                                            fontSize: 16
                                                                        }}
                                                                    >
                                                                        {unitsRuler[parseInt(el as string)]}
                                                                    </Typography>
                                                                </Paper>
                                                            )}

                                                        </div>

                                                        <Typography
                                                            style={{
                                                                fontFamily: "Poppins",
                                                                fontWeight: "bold",
                                                                fontSize: 18
                                                            }}
                                                        >
                                                            {this.getAreaPerimeter()} {unitsRuler[this.state.unitsRuler]}
                                                        </Typography>
                                                    </div>


                                                </div>
                                                <Paper
                                                    elevation={2}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        width: 30,
                                                        height: 30,
                                                        borderRadius: 20,
                                                        backgroundColor: "#ddd",
                                                        cursor: "pointer"
                                                    }}
                                                    onClick={() => {
                                                        this.setState({areaPoints: []})
                                                    }}
                                                >
                                                    <img
                                                        style={{
                                                            marginLeft: 0,
                                                            height: 20
                                                        }}
                                                        src={CleanIcon}
                                                        alt="area img"
                                                    />
                                                </Paper>
                                            </div>
                                        </Popup>
                                    }
                                </Marker>
                            )}
                        </Polygon>
                    }


                    {this.state.mostrar &&
                    <ImageOverlayRotated
                        url={this.props.product.length?
                            image_url
                            :
                            null
                        }
                        point1={this.props.product.length?
                            this.props.bounds[0] as LatLngTuple
                            :
                            null
                        }
                        point2={this.props.product.length?
                            this.props.bounds[1] as LatLngTuple
                            :
                            null
                        }
                        point3={this.props.product.length?
                            this.props.bounds[2] as LatLngTuple
                            :
                            null
                        }
                    />
                    }

                    {!this.state.cambioPopup && this.state.pixel !== null && this.state.pixelListo &&
                        <FeatureGroup>
                            <GeoJSON
                                data={[this.state.pixel as any]}
                                onEachFeature={(feature, layer) => {
                                    this.setStylePixel(feature, layer)
                                }}
                                onmouseover={() => this.setState({onParcela: true})}
                                onmouseout={() => this.setState({onParcela: false})}
                            />
                            {this.state.pixelPopup && !this.state.moving &&
                                <Popup>
                                    <Typography style={{fontWeight: "bold"}}>
                                        {Math.round(this.state.value * 100) / 100}
                                    </Typography>
                                </Popup>
                            }
                        </FeatureGroup>
                    }

                    {Object.keys(this.props.nota).length &&
                        <Marker
                            draggable={false}
                            position={this.props.nota.coords as LatLngTuple}
                            icon={pushpin_icon}
                        />
                    }

                    {this.props.notas_campo && this.state.notas.length > 0 &&
                        this.state.notas.map(nota =>
                            <Marker
                                draggable={true}
                                position={[parseFloat(nota.lat.toString()), parseFloat(nota.lng.toString())] as LatLngTuple}
                                icon={pushpin_icon}
                                ondragend={(e) => {
                                    this.updateNotePosition(nota.id.toString(), e.target.getLatLng().lat, e.target.getLatLng().lng)
                                }}
                                onclick={() => {
                                    this.props.openEditarNotaDialog(nota)
                                }}
                            />
                        )
                    }

                </Map>

                {this.state.value !== null &&
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            zIndex: 50,
                            alignSelf: "flex-end",
                            width: 50,
                            height: 'fit-content',
                            marginLeft: -110,
                            marginBottom: 30,
                            marginTop: -80,
                            borderRadius: 25,
                            backgroundColor: "transparent"
                        }}
                    >
                        {this.props.product.length !== 0 && this.props.product.split(',')[2] !== 'rgb' &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    width: 50,
                                    height: 50,
                                    borderRadius: 25,
                                    textTransform: "none",
                                    backgroundColor: this.props.zonificacion? "#80ED99" :  "#fff"
                                }}
                                onClick={() => {
                                    if (!this.props.zonificacion) {
                                        if (this.state.cargandoZonificador) return
                                        this.handleZonificador()
                                    } else {
                                        this.props.setZonificacion(false)
                                    }
                                }}
                            >

                                {this.state.cargandoZonificador?
                                    <CircularProgress
                                        style={{
                                            marginLeft: 0,
                                            height: 36,
                                            width: 36,
                                            color: "#b42333"
                                        }}
                                    />
                                    :
                                    <img
                                        style={{
                                            marginLeft: 0,
                                            height: 36,
                                            width: 36
                                        }}
                                        src={Graph}
                                        alt="wthr img"
                                    />
                                }

                            </div>
                        }

                        {this.props.zonificacion_selected.length !== 0 &&
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    cursor: "pointer",
                                    width: 50,
                                    height: 50,
                                    borderRadius: 25,
                                    textTransform: "none",
                                    backgroundColor: this.props.props_zonificacion? "#80ED99" :  "#fff"
                                }}
                                onClick={() => {
                                    if (!this.props.props_zonificacion) {
                                        if (this.state.cargandoZonificador) return
                                        this.handlePropsZonificador()
                                    } else {
                                        this.props.setPropsZonificacion(false)
                                    }
                                }}
                            >
                                {this.state.cargandoZonificador?
                                    <CircularProgress
                                        style={{
                                            marginLeft: 0,
                                            height: 36,
                                            width: 36,
                                            color: "#b42333"
                                        }}
                                    />
                                    :
                                    <img
                                        style={{
                                            marginLeft: 0,
                                            height: 36,
                                            width: 36
                                        }}
                                        src={Graph}
                                        alt="wthr img"
                                    />
                                }
                            </div>
                        }

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                width: 50,
                                height: 50,
                                borderRadius: 25,
                                textTransform: "none",
                                backgroundColor: this.state.clickedRuler? "#80ED99" :  "#fff",
                                marginTop: 5
                            }}
                            onClick={() => {
                                this.setState({
                                    clickedRuler: !this.state.clickedRuler,
                                    clickedArea: false,
                                    clickedNota: false
                                })
                            }}
                        >
                            <img
                                style={{
                                    marginLeft: 0,
                                    height: 36,
                                    width: 36
                                }}
                                src={RulerIcon}
                                alt="ruler img"
                            />
                        </div>


                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                width: 50,
                                height: 50,
                                borderRadius: 25,
                                textTransform: "none",
                                backgroundColor: this.state.clickedArea? "#80ED99" :  "#fff",
                                marginTop: 5
                            }}
                            onClick={() => {
                                this.setState({
                                    clickedArea: !this.state.clickedArea,
                                    clickedRuler: false,
                                    clickedNota: false
                                })
                            }}
                        >
                            <img
                                style={{
                                    marginLeft: 0,
                                    height: 36,
                                    width: 36
                                }}
                                src={AreaIcon}
                                alt="area img"
                            />
                        </div>

                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                width: 50,
                                height: 50,
                                borderRadius: 25,
                                textTransform: "none",
                                backgroundColor: this.state.clickedNota? "#80ED99" :  "#fff",
                                marginTop: 5
                            }}
                            onClick={() => {
                                this.setState({
                                    clickedNota: !this.state.clickedNota,
                                    clickedRuler: false,
                                    clickedArea: false
                                })
                            }}
                        >
                            <img
                                style={{
                                    marginLeft: 0,
                                    height: 36,
                                    width: 36
                                }}
                                src={NotaIcon}
                                alt="nota img"
                            />
                        </div>

                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state: IStore) => ({
    mapa: state.principal.mapa,
    zoom: state.principal.zoom,
    center: state.principal.center,
    parcela: state.visualizador.parcela,
    product: state.visualizador.product,
    bounds: state.visualizador.bounds,
    sectores: state.visualizador.sectores,
    zonificacion: state.visualizador.zonificacion,
    loading_zonificador: state.visualizador.loading_zonificador,
    zonificaciones: state.visualizador.zonificaciones,
    zonificacion_selected: state.visualizador.zonificacion_selected,
    props_zonificacion: state.visualizador.props_zonificacion,
    section:state.navegacion.section,
    nota: state.navegacion.dialogs.crear_nota,
    usuario: state.principal.usuario,
    notas_campo: state.visualizador.notas_campo,
    editar_nota: state.navegacion.dialogs.editar_nota,
    crear_nota: state.navegacion.dialogs.crear_nota,
    idioma: state.config.idioma
});

const mapDispatchToProps = (dispatch: (action: actionTypes) => void) => ({
    setMapa: (mapa: IMapas) => dispatch({type: "set-principal-mapa", mapa}),
    setZoom: (zoom: number) => dispatch({type: "set-principal-zoom", zoom}),
    setCenter: (center: LatLngTuple) => dispatch({type: "set-principal-center", center}),
    setBounds: (bounds: LatLngTuple[]) => dispatch({type: "set-visualizador-bounds", bounds}),
    setZonificacion: (zonificacion: boolean) => dispatch({type: "set-visualizador-zonificacion", zonificacion}),
    notify: (notification: INotificacion) => dispatch({type: 'notify', notification}),
    setHistograma: (histograma: Record<string, number>[]) => dispatch({type: 'set-visualizador-histograma', histograma}),
    setPropsZonificacion: (props_zonificacion: boolean) => dispatch({type: "set-visualizador-props-zonificacion", props_zonificacion}),
    openCrearNotaDialog: (data: Record<string, any>) => dispatch({type: "open-crear-nota-dialog", callback: data}),
    openEditarNotaDialog: (data: Record<string, any>) => dispatch({type: "open-editar-nota-dialog", callback: data})
});

export default connect(mapStateToProps, mapDispatchToProps)(Mapa);
